import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplateVideo: EmailTemplate = {
  id: "video",
  name: "Vidéo / Tutoriel",
  description: "Présentation avec miniature cliquable vers une vidéo (YouTube, etc.)",
  templateFile: "video",
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/1a2a6c/ffffff?text=TUTORIEL",
    videoWatchUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    videoThumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg",
    title: "Découvrez notre nouvelle fonctionnalité",
    message:
      "Regardez la vidéo ci-dessous pour découvrir comment utiliser cette nouveauté en quelques minutes.<br><br>Cette innovation va simplifier vos transferts.",
    ctaText: "Essayer maintenant",
    ctaUrl: "https://izilifepay.com",
  },
  fields: [
    { name: "heroImage", label: "Bannière", type: "image", required: false },
    {
      name: "videoWatchUrl",
      label: "Lien de la vidéo (page YouTube/Vimeo)",
      type: "url",
      required: true,
      placeholder: "https://www.youtube.com/watch?v=...",
      defaultValue: "https://www.youtube.com/watch?v=",
    },
    {
      name: "videoThumbnail",
      label: "Miniature vidéo",
      type: "image",
      required: false,
    },
    {
      name: "title",
      label: "Titre",
      type: "text",
      required: true,
      defaultValue: "Découvrez notre nouveauté",
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      required: true,
      placeholder: "Contexte autour de la vidéo...",
    },
    {
      name: "ctaText",
      label: "Texte du bouton",
      type: "text",
      required: false,
      defaultValue: "En savoir plus",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton",
      type: "url",
      required: false,
      defaultValue: "https://izilifepay.com",
    },
  ],
};
